import { axiosInstance } from "../config/axios";

// Served by grape_backend/app/chatgpt under /search/, not /web/, so pass an
// absolute URL to override the instance's baseURL.
const baseURL = `${(process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "")}/search`;
const endpoint = `${baseURL}/ai-search-query/`;
const apiKeysEndpoint = `${baseURL}/agent-api-keys/`;

export const SEARCH_SCOPE = "ai_search:read";

const errorMessages = {
	400: "Enter a search query",
	403: "Only Grape admins can use AI Search",
	502: "Search service unavailable",
};

export const runQuery = async ({ query, imageUrl, page, pageSize, raw }) => {
	const params = { query, page, page_size: pageSize };
	if (imageUrl) {
		params.image_url = imageUrl;
	}
	if (raw) {
		params.raw = "true";
	}

	try {
		const res = await axiosInstance.get(endpoint, { params });
		// raw=true returns the upstream payload as-is, without a success flag.
		return raw ? { success: true, raw: res.data } : res.data;
	} catch (e) {
		const status = e.response?.status;
		return {
			success: false,
			status,
			message:
				e.response?.data?.message ||
				errorMessages[status] ||
				"Search failed",
		};
	}
};

const apiKeyError = (e, fallback) => {
	const data = e.response?.data;
	const fieldError = data && Object.values(data).flat()[0];
	return { success: false, message: data?.detail || fieldError || fallback };
};

export const getApiKeys = async () => {
	try {
		const res = await axiosInstance.get(apiKeysEndpoint);
		return { success: true, keys: res.data };
	} catch (e) {
		return apiKeyError(e, "Could not load API keys");
	}
};

export const createApiKey = async ({ name, expiresInDays }) => {
	try {
		const res = await axiosInstance.post(apiKeysEndpoint, {
			name,
			scopes: [SEARCH_SCOPE],
			expires_in_days: expiresInDays,
		});
		return { success: true, apiKey: res.data };
	} catch (e) {
		return apiKeyError(e, "Could not generate API key");
	}
};

export const revokeApiKey = async (id) => {
	try {
		await axiosInstance.delete(`${apiKeysEndpoint}${id}/`);
		return { success: true };
	} catch (e) {
		return apiKeyError(e, "Could not revoke API key");
	}
};
